<template>
  <!--
    	作者：fzf
    	时间：2025-07-04
    	描述：商品课程留言
    -->
  <div class="product">
    <!--搜索表单-->
    <!-- <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="sh">
          <el-input size="small" v-model="searchForm.name" placeholder="课程名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div> -->

    <!--添加产品评价-->
  <!--  <div class="common-level-rail">
      <el-button size="small" type="primary" @click="addClick" icon="el-icon-plus" v-auth="'/product/comment/add'">添加评价</el-button>
    </div> -->
    <template>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="全部评价" name="-1"></el-tab-pane>
        <el-tab-pane :label="'待审核('+num+')'" name="0"></el-tab-pane>
        <el-tab-pane label="审核通过" name="1"></el-tab-pane>
        <el-tab-pane label="审核未通过" name="2"></el-tab-pane>
      </el-tabs>
    </template>

    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table  size="small" :data="tableData" border style="width: 100%" v-loading="loading">

          <el-table-column label="课程信息" width="400px">
            <template slot-scope="scope">
              {{scope.row.commentlabel}}
            </template>
          </el-table-column>

          <el-table-column prop="user.nickName" label="	用户">
            <template slot-scope="scope" >
              <p class="ww100 text-ellipsis-2"  v-if="scope.row.user != null">{{scope.row.user.nickName}}</p>
              <p class="ww100 text-ellipsis-2" v-else-if="scope.row.user == null">{{scope.row.nickName}}</p>
            </template>

          </el-table-column>

          <el-table-column prop="content" label="评价内容" width="200">
            <template slot-scope="scope">
              <p class="ww100 text-ellipsis-2">{{scope.row.content}}</p>
            </template>
          </el-table-column>

          <el-table-column prop="status" label="评价状态">
            <template slot-scope="scope">
              <span v-if="scope.row.status==0" class="red fb">待审核</span>
              <span v-if="scope.row.status==1" class="green">审核通过</span>
              <span v-if="scope.row.status==2" class="gray9">审核未通过</span>
            </template>
          </el-table-column>
          <el-table-column prop="sort" label="排序"></el-table-column>
          <el-table-column prop="create_time" label="评论时间"></el-table-column>
          <el-table-column fixed="right" label="操作" width="90">
            <template slot-scope="scope">
              <el-button @click="detailClick(scope.row)" type="text" size="small" v-auth="'/product/comment/detail'">详情</el-button>
              <el-button @click="delClick(scope.row)" type="text" size="small" v-auth="'/product/comment/delete'">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage"
          :page-size="pageSize" layout="total, prev, pager, next, jumper"
          :total="totalDataNumber">
        </el-pagination>
      </div>
    </div>
      <!--添加评价-->
      <Add v-if="open_add" :open_add="open_add" :addform="categoryModel" @closeDialog="closeDialogFunc($event, 'add')"></Add>

  </div>
</template>

<script>
  import PorductApi from '@/api/product.js';
  import Add from './Add.vue';

  export default {
    components: {
      Add,

    },
    data() {
      return {
        loading: true,
        activeName: '-1',
        num: 0,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*总条数*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*搜索参数*/
        searchForm: {
          score: 0,
          name: ''
        },
        status: -1,
        /*是否打开添加弹窗*/
        open_add: false,
        /*当前编辑的对象*/
        categoryModel: {
          catList: [],
          model: {}
        }

      };
    },
    created() {
      /*获取列表*/
      this.getData();
    },
    methods: {

      /*选择第几页*/
      handleCurrentChange(val) {
        let self = this;
        self.curPage = val;
        self.loading = true;
        let Params = self.searchForm;
        self.getData(Params);
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getData();
      },

      /*获取列表*/
      getData(param = '') {
        let self = this;
        let Params = {};
        Params.status = self.status;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        if (param != '') {
          Params.score = param.score;
          Params.name = param.name;
        }
        PorductApi.getCommentListxd(Params, true).then(res => {
          self.loading = false;
          self.tableData = res.data.list.data;
          self.totalDataNumber = res.data.list.total
          self.num = res.data.num;
        }).catch(error => {
          self.loading = false;
        });
      },

      /*打开编辑*/
      detailClick(row) {
        this.$router.push({
          path: '/product/comment/Detail',
          query: {
            comment_id: row.comment_id,
          }
        });
      },

      /*订单详情*/
      orderClick(row) {
        this.$router.push({
          path: '/product/comment/Order',
          query: {
            order_id: row.order_id,
          }
        });
      },

      /*删除*/
      delClick: function(row) {
        let self = this;
        self.$confirm('删除后不可恢复，确认删除该记录吗?', '提示', {
          type: 'warning'
        }).then(() => {
          PorductApi.delComment({
            comment_id: row.comment_id
          }).then(data => {
            self.$message({
              message: '删除成功',
              type: 'success'
            });
            self.getData();
          });
        });
      },

      /*搜索查询*/
      onSubmit() {
        let self = this;
        self.loading = true;
        let Params = self.searchForm;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        Params.status = self.status;
        PorductApi.getCommentList(Params, true).then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;

          self.totalDataNumber = data.data.list.total
        }).catch(error => {
          self.loading = false;
        });
      },

      /*切换选项卡*/
      handleClick(tab, event) {
        let self = this;
        self.curPage = 1;
        self.loading = true;
        self.status = tab.name;
        self.getData();
      },
       /*打开添加*/
      addClick() {
        this.open_add = true;
      },


      /*关闭弹窗*/
      closeDialogFunc(e, f) {
        if (f == 'add') {
          this.open_add = e.openDialog;
          if (e.type == 'success') {
            this.getData();
          }
        }
        if (f == 'edit') {
          this.open_edit = e.openDialog;
          if (e.type == 'success') {
            this.getData();
          }
        }
      },
    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/product/comment/indexxd.vue